import icon from "../../../assets/icon.png";
import { ReactNode } from "react";

const LoginLayout = ({ children }: { children: ReactNode }) => {
  return (
    <main className="overflow-x-hidden">
      <div className="flex min-h-screen">
        {/* Left: form panel */}
        <div className="w-full lg:w-1/2 px-6 flex items-center justify-center">
          <div className="w-full max-w-md py-12">
            <div className="mb-8">
              <img src={icon} alt="logo_scanifood" className="w-16 mb-4" />
              <h1 className="text-2xl font-bold text-card-foreground">
                ScaniFood
              </h1>
              <p className="text-sm text-muted-foreground mt-1">
                Gérez votre restaurant en toute simplicité
              </p>
            </div>

            {children}
          </div>
        </div>

        {/* Right: illustration panel */}
        <div className="hidden lg:flex w-1/2 bg-gradient-to-br from-[#1a1a2e] via-[#16213e] to-[#0f3460] relative overflow-hidden items-center justify-center">
          {/* Decorative circles */}
          <div className="absolute top-[-100px] right-[-100px] w-[400px] h-[400px] rounded-full bg-white/5" />
          <div className="absolute bottom-[-150px] left-[-100px] w-[500px] h-[500px] rounded-full bg-white/5" />
          <div className="absolute top-[40%] right-[10%] w-[200px] h-[200px] rounded-full bg-white/5" />
          <div className="absolute bottom-[20%] left-[15%] w-[150px] h-[150px] rounded-full border-2 border-dashed border-white/15" />
          <div className="absolute top-[15%] left-[20%] w-[80px] h-[80px] rounded-full border-2 border-dashed border-white/10" />

          {/* Content */}
          <div className="relative z-10 text-center text-white px-12 max-w-md">
            <img src={icon} alt="logo" className="w-20 h-20 mx-auto mb-6 rounded-xl" />
            <h2 className="text-3xl font-bold mb-4">
              Bienvenue sur ScaniFood
            </h2>
            <p className="text-white/70 text-base leading-relaxed">
              La solution complète pour gérer vos commandes, menus et équipes en temps réel.
            </p>

            {/* Feature pills */}
            <div className="flex flex-wrap justify-center gap-2 mt-8">
              <span className="px-3 py-1.5 rounded-full bg-white/10 text-white/80 text-xs font-medium backdrop-blur-sm">
                Commandes en temps réel
              </span>
              <span className="px-3 py-1.5 rounded-full bg-white/10 text-white/80 text-xs font-medium backdrop-blur-sm">
                Menu digital
              </span>
              <span className="px-3 py-1.5 rounded-full bg-white/10 text-white/80 text-xs font-medium backdrop-blur-sm">
                Gestion d'équipe
              </span>
              <span className="px-3 py-1.5 rounded-full bg-white/10 text-white/80 text-xs font-medium backdrop-blur-sm">
                Tableau de bord
              </span>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default LoginLayout;
